export const OTHER_REASON_FOR_VENDOR_REPLACEMENT = 'other (please enter reason)';
export const NO_VENDOR_FOUND = 'No matching vendors found';
